import React from "react"
import styled from "styled-components"

const StyledH1 = styled.h1`
  margin: 0;
  min-height: 100%;
  font-size: 2rem;
`

export const DetailTitle = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledH1>) => {
  return <StyledH1 {...props}>{children}</StyledH1>
}
